// useDeviceType.ts
import { useEffect, useState } from 'react';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

type Breakpoints = {
  tablet: number;   // >= tablet
  desktop: number;  // >= desktop
};

export function useDeviceType(
  breakpoints: Breakpoints = { tablet: 768, desktop: 1024 }
) {
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop');

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mq = {
      mobile: window.matchMedia(`(max-width: ${breakpoints.tablet - 1}px)`),
      tablet: window.matchMedia(
        `(min-width: ${breakpoints.tablet}px) and (max-width: ${breakpoints.desktop - 1}px)`
      ),
      desktop: window.matchMedia(`(min-width: ${breakpoints.desktop}px)`),
    };

    const compute = (): DeviceType =>
      mq.mobile.matches ? 'mobile' : mq.tablet.matches ? 'tablet' : 'desktop';

    const onChange = () => setDeviceType(compute());

    // 1) первинне визначення
    setDeviceType(compute());

    // 2) підписки (з урахуванням старих браузерів)
    const add = (m: MediaQueryList) =>
      m.addEventListener ? m.addEventListener('change', onChange) : m.addListener(onChange);
    const remove = (m: MediaQueryList) =>
      m.removeEventListener ? m.removeEventListener('change', onChange) : m.removeListener(onChange);

    add(mq.mobile); add(mq.tablet); add(mq.desktop);
    return () => { remove(mq.mobile); remove(mq.tablet); remove(mq.desktop); };
  }, [breakpoints.tablet, breakpoints.desktop]);

  return {
    deviceType,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
  };
}




// import { useEffect, useState } from 'react';

// export function useDeviceTypeJS(breakpoints = { tablet: 768, desktop: 1024 }) {
//   const [type, setType] = useState('desktop');

//   useEffect(() => {
//     if (typeof window === 'undefined' || !window.matchMedia) return;
//     const mq = {
//       m: window.matchMedia(`(max-width: ${breakpoints.tablet - 1}px)`),
//       t: window.matchMedia(`(min-width: ${breakpoints.tablet}px) and (max-width: ${breakpoints.desktop - 1}px)`),
//       d: window.matchMedia(`(min-width: ${breakpoints.desktop}px)`),
//     };
//     const compute = () => setType(mq.m.matches ? 'mobile' : mq.t.matches ? 'tablet' : 'desktop');
//     compute();
//     const on = (x) => x.addEventListener ? x.addEventListener('change', compute) : x.addListener(compute);
//     const off = (x) => x.removeEventListener ? x.removeEventListener('change', compute) : x.removeListener(compute);
//     on(mq.m); on(mq.t); on(mq.d);
//     return () => { off(mq.m); off(mq.t); off(mq.d); };
//   }, [breakpoints.tablet, breakpoints.desktop]);

//   return { deviceType: type, isMobile: type === 'mobile', isTablet: type === 'tablet', isDesktop: type === 'desktop' };
// }
